import { useNavigate } from 'react-router-dom';
import { t, Tabs } from '@kanbios/ui';

/** Section tabs of Domaines (D27): the addresses served, the domain names and their registry expiry (SPEC-029). */
export function DomainsTabs({ value }: { value: 'addresses' | 'names' }) {
  const navigate = useNavigate();
  return (
    <Tabs
      label={t('addresses.sections')}
      value={value}
      onChange={id => navigate(id === 'names' ? '/domains/names' : '/domains')}
      items={[{ id: 'addresses', label: t('addresses.tabs.addresses') }, { id: 'names', label: t('addresses.tabs.names') }]}
    />
  );
}
